import React from 'react';
import styles from './user_intro.module.scss';
import {CustomerFieldKeys, getValue} from '../../../support/get_data.ts';
import {__} from '../../../support/lang/translations.ts';
import {Avatar} from '../../../components/avatar/avatar.tsx';
import {Size} from '../../../enums/size.ts';
import {CustomerAccountType} from '../../../gql/customer/graphql.ts';
import {HideElement} from '../../../components/utility/hide_element_wrapper.tsx';

interface OwnProps {
    customerAccount?: CustomerAccountType | null;
    companyName?: string | null;
    children?: React.ReactNode;
}
export function UserIntro({customerAccount, companyName, children}: OwnProps) {
    const name = getValue(customerAccount?.customer, CustomerFieldKeys.NAME)?.value;
    const email = getValue(customerAccount?.customer, CustomerFieldKeys.EMAIL)?.value;
    const pictureUrl = customerAccount?.customer?.profilePicture?.signed_url;

    return (
        <div className={styles.user_intro}>
            <HideElement size={'md'}>
                <div className={styles.intro_avatar}>
                    <Avatar name={name ?? email ?? ''} src={pictureUrl} editable={false} size={Size.Medium} />
                </div>
            </HideElement>

            <div className={styles.intro_user}>
                {customerAccount && (
                    <h1 className={styles.hero_title}>
                        <HideElement size={'md'}>
                            {__('dashboard.titles.welcome.greeting')} {name ?? email}
                            <br />
                            <br />
                        </HideElement>
                        {__(`dashboard.titles.welcome.welcome_team`)} {companyName}{' '}
                        {__(`dashboard.titles.welcome.welcome_company`)}
                    </h1>
                )}
            </div>

            {children}
        </div>
    );
}
